/* src/views/ServicesView.js */
import { ref, computed, onMounted } from 'vue';
import { X, Trash2, Plus, Search, Euro, Clock, Edit, AlertCircle, PlusCircle, Layers, Check } from 'lucide-vue-next';
import { ServicesService } from '@/services/ServicesService';
import { SkillsService } from '@/services/SkillsService';
import { ResourcesService } from '@/services/ResourcesService';

export default {
  name: 'ServicesView',
  components: { X, Trash2, Plus, Search, Euro, Clock, Edit, AlertCircle, PlusCircle, Layers, Check },
  setup() {
    const availableSkills = ref([]);
    const availableResourceCategories = ref([]);
    const services = ref([]);
    const searchQuery = ref('');
    const isDrawerOpen = ref(false);
    const validationError = ref('');

    const getEmptyForm = () => ({
      id: 0, name: '', description: '', price: 0, duration: 30,
      operatorMode: 'any', checkInventory: false, requiredSkills: [],
      requiredResourceCats: [], hasQuestions: false, questions: [],
      usePaymentOverride: false,
      paymentRule: { type: 'deposit', value: 0, unit: '%' }
    });

    const serviceForm = ref(getEmptyForm());

    const fetchAll = async () => {
    
      try {

        const data = await ServicesService.getAll()
        services.value = data || []
        availableSkills.value = await SkillsService.getAll() || []
        availableResourceCategories.value = await ResourcesService.getAllCategories() || []
      } 
      catch (e) { 

        console.error("Errore caricamento:", e)
      }
    }

    onMounted(fetchAll);

    // Computed corretta per evitare il crash
    const filteredServices = computed(() => {
      if (!services.value) return [];
      return services.value.filter(s => 
        s.name.toLowerCase().includes(searchQuery.value.toLowerCase())
      );
    });

    const getSkillNames = (ids) => availableSkills.value.filter(s => ids.includes(s.id)).map(s => s.name).join(', ')
    const closeDrawer = () => { isDrawerOpen.value = false }
    const openCreate = () => { serviceForm.value = getEmptyForm(); isDrawerOpen.value = true }

    const openEdit = (srv) => {

      serviceForm.value = getEmptyForm()
      serviceForm.value.id = srv.id
      serviceForm.value.name = srv.name
      serviceForm.value.description = srv.description
      serviceForm.value.price = srv.price
      serviceForm.value.duration = srv.duration
      serviceForm.value.selectionMode = srv.selectionMode
      serviceForm.value.checkInventory = srv.checkInventory
      serviceForm.value.requiredSkills = [...srv.requiredSkills]
      serviceForm.value.requiredResourceCats = [...srv.requiredResourceCats]
      serviceForm.value.hasQuestions = srv.hasQuestions
      serviceForm.value.questions = [...srv.questions]

      if (srv.paymentRule && srv.paymentRule.type) {

        serviceForm.value.usePaymentOverride = true
        serviceForm.value.paymentRule.type = srv.paymentRule.type
        serviceForm.value.paymentRule.value = srv.paymentRule.value
        serviceForm.value.paymentRule.unit = srv.paymentRule.unit
      } 
      else {

        serviceForm.value.usePaymentOverride = false
        serviceForm.value.paymentRule = { type: 'deposit', value: 0, unit: '%' }
      }

      isDrawerOpen.value = true
    }

    const saveService = async () => {

      try {

        const data = { ...serviceForm.value }
        data.payment_rule = data.usePaymentOverride ? data.paymentRule : null
        delete data.usePaymentOverride
        delete data.paymentRule

        if (data.id && data.id !== 0) {

          await ServicesService.update(data.id, data)
        } 
        else {

          await ServicesService.create(data)
        }

        await fetchAll()
        closeDrawer()
      } 
      catch (e) {

        console.error("Errore salvataggio:", e)
        validationError.value = "Errore nel salvataggio: " + (e.message || "Controlla i dati")
      }
    }
    const addQuestion = () => serviceForm.value.questions.push({ label: '', type: 'text', options: '', required: false });
    const removeQuestion = (index) => serviceForm.value.questions.splice(index, 1);
    const toggleArraySelection = (arr, id) => {
      const idx = arr.indexOf(id);
      idx > -1 ? arr.splice(idx, 1) : arr.push(id);
    };

    return {
      availableSkills, availableResourceCategories, services, filteredServices, searchQuery, isDrawerOpen, validationError,
      serviceForm, closeDrawer, openCreate, openEdit, saveService, addQuestion, removeQuestion, toggleArraySelection, getSkillNames
    };
  }
};